module.exports = __webpack_public_path__ + "static/img/check.66c66a44.svg";